import { IState } from "@Types";

export default {
  state: {
    local: "en"
  },
  getters: {
    GET_LOCAL: (state: IState) => state.local
  },
  actions: {
    SET_LOCAL: ({ commit }: any, data: string) => {
      commit("SET_LOCAL", data);
    }
  },
  mutations: {
    SET_LOCAL: (state: IState, data: string) => {
      state.local = data;
    }
  }
};
